<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>渠道用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>业务员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        :model="userSearchData"
        size="small"
        :inline="true"
        label-width="68px">
        <el-form-item label="用户ID">
          <el-input
            v-model="userSearchData.user_id"
            placeholder="请输入用户ID"
            size="small"
            clearable
            style="width:150px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input
            v-model="userSearchData.name"
            placeholder="请输入用户名称/微信昵称"
            size="small"
            clearable
            style="width:150px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="userSearchData.time"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchDataInfo()">App用户信息搜索</el-button>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchChannelDataInfo()">渠道用户信息搜索</el-button>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="addversion"
            >新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="pageloading" border :data="versionListData" stripe style="width: 100%">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width">
        </el-table-column>
        <el-table-column prop="address" label="操作" width="450" fixed="right">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="edit(scope.row)">添加业务员</el-button>
            <el-button type="success" size="mini" @click="edit(scope.row)">编辑业务员</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
      <!-- 分页功能 -->
    </el-card>

    <!-- 添加版本弹框 -->
    <el-dialog v-loading="editpageloading" title="新增业务员" :visible.sync="addVisible" width="50%">
      <el-form
        :model="addruleForm"
        ref="addruleForm"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item label="渠道商ID" prop="channel_user_id">
          <el-input v-model="addruleForm.channel_user_id"></el-input>
        </el-form-item>
        <el-form-item label="App用户ID" prop="app_user_id">
          <el-input v-model="addruleForm.app_user_id"></el-input>
        </el-form-item>
        <el-form-item label="业务员等级" prop="grade">
          <el-radio-group v-model="editruleForm.grade">
            <el-radio label="1">1级业务员</el-radio>
            <el-radio label="2">2级业务员</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="红包区分成比例" prop="hongbao_divide_prent">
          <el-input v-model="addruleForm.hongbao_divide_prent"></el-input>
        </el-form-item>
        <el-form-item label="新年红包分成比例" prop="year_hongbao_divide_prent">
          <el-input v-model="addruleForm.year_hongbao_divide_prent"></el-input>
        </el-form-item>
        <el-form-item label="专区游戏充值分成比例" prop="game_pay_divide_prent">
          <el-input v-model="addruleForm.game_pay_divide_prent"></el-input>
        </el-form-item>
        <el-form-item label="业务员等级" prop="status">
          <el-radio-group v-model="addruleForm.status">
            <el-radio label="1">正常</el-radio>
            <el-radio label="2">不参与分成</el-radio>
            <el-radio label="3">结算冻结</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分成时间">
          <el-date-picker
            v-model="addruleForm.start_time"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']">
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addsubmitForm('addruleForm')">添加内容</el-button>
          <el-button @click="addresetForm('addruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加版本弹框 -->

    <!-- 编辑版本弹框 -->
    <el-dialog  v-loading="editpageloading" title="编辑业务员" :visible.sync="editVisible" width="50%">
      <el-form
        :model="editruleForm"
        ref="editruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户ID" prop="user_id" :readonly="true">
          <el-input v-model="editruleForm.user_id"></el-input>
        </el-form-item>
        <el-form-item label="渠道商ID" prop="channel_user_id" :readonly="true">
          <el-input v-model="editruleForm.channel_user_id"></el-input>
        </el-form-item>
        <el-form-item label="App用户ID" prop="app_user_id" :readonly="true">
          <el-input v-model="editruleForm.app_user_id"></el-input>
        </el-form-item>
        <el-form-item label="业务员等级" prop="grade">
          <el-radio-group v-model="editruleForm.grade">
            <el-radio :label="1">1级业务员</el-radio>
            <el-radio :label="2">2级业务员</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="红包区分成比例" prop="hongbao_divide_prent">
          <el-input v-model="editruleForm.hongbao_divide_prent"></el-input>
        </el-form-item>
        <el-form-item label="新年红包分成比例" prop="year_hongbao_divide_prent">
          <el-input v-model="editruleForm.year_hongbao_divide_prent"></el-input>
        </el-form-item>
        <el-form-item label="专区游戏充值分成比例" prop="game_pay_divide_prent">
          <el-input v-model="editruleForm.game_pay_divide_prent"></el-input>
        </el-form-item>
        <el-form-item label="业务员等级" prop="status">
          <el-radio-group v-model="editruleForm.status">
            <el-radio label="1">正常</el-radio>
            <el-radio label="2">不参与分成</el-radio>
            <el-radio label="3">结算冻结</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分成时间">
          <el-date-picker
            v-model="editruleForm.start_time"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']">
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editsubmitForm('editruleForm')">提交修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑弹框 -->
  </div>
</template>

<script>
// import { changeDateFormat } from "@/utils/util";
import { getcurrentTime } from "@/utils/public";
import { isString, getCookie } from '../../utils/util';
export default {
  data() {
    return {
      pageloading: false,
      editpageloading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0, //请求列表的总条数
      userSearchData: {
        user_id: "",
        name: "",
        time: ""
      },
      // 添加版本信息数据
      addruleForm: {
        channel_user_id: "",
        app_user_id: "",
        grade: "",
        hongbao_divide_prent: "",
        year_hongbao_divide_prent: "",
        game_pay_divide_prent: "",
        status: "",
        start_time: [],
        s_time: "",
        e_time: ""
      },
      // 修改版本信息数据
      editruleForm: {
        id: "",
        user_id: "",
        channel_user_id: "",
        app_user_id: "",
        grade: "",
        hongbao_divide_prent: "",
        year_hongbao_divide_prent: "",
        game_pay_divide_prent: "",
        status: "",
        start_time: [],
        s_time: "",
        e_time: ""
      },
      tablecolumns: [
        {
          column_name: "",
          column_comment: "",
        }
      ],
      tableData: [],
      versionListData: [],
      addVisible: false,
      editVisible: false
    };
  },

  mounted() {
    this.searchDataInfo();
  },

  methods: {
    changeDateFormat(time, format = 'YYYY-MM-DD hh:mm:ss') {
      if(!time) return '';
      var datetime = new Date(time);
      var o = {
          'Y+': datetime.getFullYear(),
          "M+": datetime.getMonth() + 1,
          "D+": datetime.getDate(),
          "h+": datetime.getHours(),
          "m+": datetime.getMinutes(),
          "s+": datetime.getSeconds(),
          "q+": Math.floor((datetime.getMonth() + 3) / 3),
          "S": datetime.getMilliseconds()
      };
      if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          }
      }
      return format;
    },
    // 添加用户弹框
    addversion() {
      this.addVisible = true;
    },
    // 添加用户按钮
    addsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let time = getcurrentTime();
          this.addruleForm.create_time = time;
          console.log(this.addruleForm);
          //添加版本
          this.addVersionData(this.addruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置添加用户
    addresetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 点击编辑行内容并更改数据
    edit(data) {
      this.editVisible = true;
      for(var k in data) {
        this.editruleForm[k] = data[k];
      }
    },
    editsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editVisible = false;
          this.updateDataInfo(this.editruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editresetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 编辑version
    async updateDataInfo(requestObject) {
      var user_id = getCookie('user_id');
      this.$axios
        .post("/3699BIApi/AdminDataSumShowGroupConfig/UpdateData",{
            id: Number.parseInt(requestObject.id),
            user_id: Number.parseInt(user_id),
            channel_user_id: Number.parseInt(channel_user_id),
            name: requestObject.name,
            text: requestObject.text
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          if (res.data.code == "200") {
            this.$message.success("编辑成功");
            this.searchDataInfo();
          } else {
            this.$message.error("编辑失败");
          }
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchData(this.userSearchData);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchData(this.userSearchData);
    },
    async addVersionData(requestObject) {
      var user_id = getCookie('user_id');
      this.editpageloading = true;
      this.$axios
      .post("/3699BIApi/AdminDataSumShowGroupConfig/AddData",{
          user_id: Number.parseInt(user_id),
          channel_user_id: Number.parseInt(channel_user_id),
          name: requestObject.name,
          text: requestObject.text
      })
      .then(res => {
        this.editpageloading = false;
        if (res.data.code == "200") {
          this.addVisible = false;
          this.searchDataInfo();
          this.$message('添加成功！');
        }
        else {
          console.log(res.data.message);
          this.$message.error(`添加失败:${res.data.message}`);
        }
      });
    },
    async searchData(requestObject) {
      this.$axios
      .post("/3699BIApi/AdminDataSumShowGroupConfig/SearchData",{
          user_id: Number.parseInt(requestObject.user_id),
          name: requestObject.name,
          create_time: requestObject.time[0],
          update_time: requestObject.time[1],
          currentPage: this.currentPage,
          pageSize: this.pageSize
      })
      .then(res => {
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.tableColumns = res.data.columns;
          this.updateCurrpageData();
      });
    },
    searchDataInfo() {
      this.pageloading = true;
      this.searchData(this.userSearchData);
    },
    async searchChannelData(requestObject) {
      this.$axios
      .post("/3699BIApi/AdminDataSumShowGroupConfig/SearchData",{
          user_id: Number.parseInt(requestObject.user_id),
          name: requestObject.name,
          create_time: requestObject.time[0],
          update_time: requestObject.time[1],
          currentPage: this.currentPage,
          pageSize: this.pageSize
      })
      .then(res => {
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.tableColumns = res.data.columns;
          this.updateCurrpageData();
      });
    },
    searchChannelDataInfo() {
      this.pageloading = true;
      this.searchChannelData(this.userSearchData);
    },
    updateCurrpageData() {
      var arrays = [];
      var i = 0;
      var endi = this.total - (this.currentPage-1) * this.pageSize;
      if (endi > this.pageSize) {
        endi = this.pageSize;
      }
      console.log(`updateCurrpageData ${endi} 条`);
      for(; i<endi; i++) {
        if (i < this.total) {
          var itemObject = this.tableData[i];
          arrays.push(itemObject);
        }
      }
      
      this.versionListData = arrays.filter(val => {
        return val;
      });
    },
    async deleteDataInfo(data) {
      this.deleteData(data);
    },  
    // 删除
    async deleteData(data) {
      try {
        let msg = await this.$confirm("确认删除吗?");
        if (msg =  `confirm`) {
          this.deleteDataApi(data);
        }
      } catch (error) {
        return console.log("出错了：" + error);
      }
    },
    // 删除
    async deleteDataApi(data) {
      this.editpageloading = true;
      this.$axios
        .post("/3699BIApi/AdminDataSumShowGroupConfig/DeleteData",{
          id: Number.parseInt(data.Id)
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          this.pageloading = false;
          if (res.data.code == "200") {
            this.$message.success("删除成功");
            this.searchDataInfo();
          } else {
            this.$message.error("删除失败");
          }
        },
        (error)=>{
          this.editpageloading = false;
          this.$message('请求报错：' + error);
        });
    },
  }
};
</script>

<style lang="sass" scoped>
</style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         


// WEBPACK FOOTER //
// src/views/ChannelUser/ChannelPriceUser.vue